<template>
  <div :class="mode">
    <div
      v-if="listMode === 'icon'"
      class="icon-mode-bg"
    >
      <svg class="file-icon"><use :xlink:href="iconType" /></svg>
    </div>
    <div class="file-area">
      <svg
        v-if="listMode !== 'icon'"
        class="file-icon"
      ><use :xlink:href="iconType" /></svg>
      <input
        v-model="filename"
        v-focus
        class="creat-file"
        type="text"
        @keyup.enter="createFolder()"
      >
      <span class="wrap-btns">
        <span
          class="re-icon"
          @click="createFolder()"
        >
          <svg class="new-folder-tick"><use xlink:href="#newtick" /></svg>
        </span>
        <span
          id="re-icon-cancel"
          class="re-icon"
          @click="cancel()"
        >
          <svg class="new-folder-cancel"><use xlink:href="#newcancel" /></svg>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import * as Util from 'js/util/util'
import store from 'store'

const { postData } = require('js/api/getdata').default

export default {
  name: 'ListModeComponentTemplate',
  directives: {
    focus: {
      // 指令的定义
      inserted(el) {
        // 聚焦元素
        setTimeout(() => {
          el.focus()
          el.select()
        }, 0)
      },
    },
  },
  props: {
    fileInfo: {
      type: Object,
      default: () => {},
    },
    mountEl: {
      type: HTMLElement,
      default: () => {},
    },
    vm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      filename: this.vm.$t(this.fileInfo.filename) || this.vm.$t('新建文件夹'),
      alreadyClick: false,
    }
  },
  computed: {
    mode() {
      if (localStorage.getItem('Mode') === 'icon') {
        return 'card-mode'
      }
      return ''
    },
    iconType() {
      if (this.fileInfo.fileType) {
        return `#${Util.typeIcon(this.fileInfo.fileType)}`
      }
      return '#folder'
    },
    listMode() {
      return localStorage.getItem('Mode') || 'list'
    },
  },
  watch: {
    filename(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.alreadyClick = false
      }
    },
  },
  methods: {
    createFolder() {
      if (this.alreadyClick) return
      this.alreadyClick = true
      const { vm } = this
      const info = this.fileInfo
      if (this.mountEl) {
        vm.createFolder(this.filename, info)
        vm.close()
        return
      }
      if (info.fileType === '' || info.fileType === undefined) {
        this.filename = this.filename.trimRight() // 新建文件夹时文件夹末尾的空格去掉
        if (Util.validFolderName(this.filename) === false) {
          vm.$emit('showTips', `${vm.$t('文件夹名称不能包括下列任何字符')}: \\/:*?"<>|`, 'warn')
          return
        }
      } else if (Util.validFilename(this.filename) === false) {
        vm.$emit('showTips', `${vm.$t('文件名称不能包括下列任何字符')}: \\/:*?"<>|`, 'warn')
        return
      }
      if (!Util.validEmpty(this.filename)) {
        if (info.fileType === '' || info.fileType === undefined) {
          vm.$emit('showTips', vm.$t('文件夹名不能为空或空格'), 'warn')
          return
        }
        vm.$emit('showTips', vm.$t('文件名不能为空或空格'), 'warn')
        return
      }
      if (this.filename.trim().startsWith('.')) {
        vm.$emit('showTips', vm.$t('文件或文件夹名称不能以.开头'), 'warn')
        return
      }
      // 公有原来的参数
      const data = {
        path_type: info.pathType,
        dc_id: info.dcId,
        file_type: info.fileType || '',
        from: info.from || '',
        prefix_neid: info.prefix_neid || '',
      }
      // 私有新建文件参数
      const fileData = {
        file_type: info.fileType || '',
        dc_url: '',
        path: '',
        path_type: info.pathType,
        template_name: encodeURIComponent(this.filename),
        from: info.from || '',
        prefix_neid: info.prefix_neid || '',
        nsid: store.state.tempFileListState.tempNsid,
      }
      // 私有新建文件夹参数
      const folderData = {
        is_update: false,
        path_type: info.pathType,
        from: info.from || '',
        prefix_neid: info.prefix_neid || '',
        nsid: store.state.tempFileListState.tempNsid,
        pid: store.state.tempFileListState.tempPid,
      }
      let createType
      let fileSize // 私有字段(验证上传权限)
      switch (info.fileType) {
        case 'docx':
          fileSize = 14406
          break
        case 'xlsx':
          fileSize = 10423
          break
        case 'pptx':
          fileSize = 26820
          break
        default:
          fileSize = 0
      }
      // 新建文件验证权限参数
      const authData = {
        path_type: info.pathType,
        bytes: fileSize,
        // 增加nsid
        nsid: store.state.tempFileListState.tempNsid,
      }

      if (info.fileType === '' || info.fileType === undefined) {
        createType = 'createFolder'
      } else {
        createType = 'createFile'
      }
      let urlTail; const param = {}; const
        path = localStorage.getItem('currentPath')

      if (data.file_type !== '' && path !== '/') {
        urlTail = `${path}/${this.filename}.${data.file_type}`
      } else if (data.file_type !== '' && path === '/') {
        urlTail = `/${this.filename}.${data.file_type}`
      } else if (info.currentPath && info.currentPath !== '/') {
        urlTail = `${info.currentPath}/${this.filename}`
      } else if (info.currentPath && info.currentPath === '/') {
        urlTail = `/${this.filename}`
      } else if (path !== '/') {
        urlTail = `${path}/${this.filename}`
      } else {
        urlTail = `/${this.filename}`
      }
      // 私有收到的共享页面新建需要另外两个参数
      if (info.pathType === 'share_in') {
        if (createType === 'createFolder') {
          folderData.prefix_neid = store.state.tempFileListState.tempShareInPrefixNeid
          folderData.from = store.state.tempFileListState.tempShareInFrom
        } else {
          fileData.prefix_neid = store.state.tempFileListState.tempShareInPrefixNeid
          fileData.from = store.state.tempFileListState.tempShareInFrom
          // 权限验证
          authData.prefix_neid = store.state.tempFileListState.tempShareInPrefixNeid
          authData.from = store.state.tempFileListState.tempShareInFrom
        }
      }
      // 私有新建文件需要验证有无上传权限，故使用以下方法
      if (createType === 'createFolder') {
        // 新建文件夹
        folderData.targetPath = urlTail
        postData('createFolder', folderData).then((res) => {
          if (res.status === 200) {
            this.cancel()
            vm.$emit('showTips', vm.$t('成功创建“{name}”文件夹', { name: Util.pathToName(res.data.path) }), 'success')
            let timer
            clearTimeout(timer)
            timer = setTimeout(() => {
              // 老的逻辑直接刷新列表
              // vm.$emit('refreshList',{url: info.currentPath, refresh: true})
              // 新的逻辑  置顶、不刷新列表
              const { data: creatFolderData } = res
              const params = {
                neid: creatFolderData.neid,
                target_path: creatFolderData.path,
                path_type: creatFolderData.path_type,
                prefix_neid: creatFolderData.prefix_neid,
                limit: '',
                offset: 0,
                include_deleted: false,
              }
              if (info.pathType === 'share_in' || info.pathType === 'share_out') {
                params.prefix_neid = store.state.tempFileListState.tempShareInPrefixNeid
                params.from = store.state.tempFileListState.tempShareInFrom
                params.nsid = store.state.tempFileListState.tempNsid
              }
              postData('getMetadata', params).then((metaDataRes) => {
                if (metaDataRes.status === 200) {
                  const self = vm
                  const newFolderData = metaDataRes.data
                  delete newFolderData.content
                  newFolderData.isfolder = newFolderData.is_dir
                  newFolderData.isDir = newFolderData.is_dir
                  newFolderData.checked = false
                  newFolderData.islocked = !!newFolderData.lock_uid
                  newFolderData.unlockAdmin = (newFolderData.lock_uid === Util.getUserID())
                  || Util.isAdmin()
                  newFolderData.data = [{
                    type: 'file',
                    showRename: false,
                    get value() {
                      return newFolderData.filename ? newFolderData.filename : newFolderData.path.split('/').pop()
                    },
                    fileMore: [],
                    class: 'filelist-icon',
                  }, {
                    get value() {
                      const isListMode = localStorage.getItem('Mode') === 'list'
                      if (isListMode) {
                        return `${Util.formatDate(newFolderData.modified, 'yyyy-MM-dd hh:mm')} | ${newFolderData.updator}`
                      }
                      return Util.formatDate(newFolderData.modified, 'yyyy-MM-dd hh:mm') + self.$t(' 由{n}创建', { n: newFolderData.updator })
                    },
                    class: 'update-date-updator',
                  }, {
                    get value() {
                      return newFolderData.is_dir ? '-' : Util.formatBytes(newFolderData.bytes)
                    },
                    class: 'update-size',
                  }]
                  store.commit('addCreateData', newFolderData)
                  vm.$emit('getCreateData', newFolderData)
                }
              }).catch((error) => {
                const err = error.response.data
                vm.$emit('showTips', err.message, 'error')
              })
            }, 300)
          }
        }).catch((error) => {
          const err = error.response.data
          vm.$emit('showTips', err.message, 'error')
          if (error.response.status === 400) {
            this.cancel()
          }
        })
      } else if (createType === 'createFile') {
        authData.url = urlTail
        authData.target_path = urlTail
        fileData.path = urlTail
        // 先验证上传权限
        postData('getAuthUpload', authData, param).then((authUploadRes) => {
          if (authUploadRes.status === 200) {
            fileData.dc_url = authUploadRes.data.region
            if (urlTail.indexOf('/') === 0) {
              fileData.path = encodeURIComponent(urlTail.slice(1))
            } else {
              fileData.path = encodeURIComponent(urlTail)
            }
            postData(createType, fileData, param).then((res) => {
              if (res.status === 200) {
                this.cancel()
                vm.$emit('showTips', vm.$t('成功创建“{name}”文件', { name: Util.pathToName(res.data.entity.path) }), 'success')
                let timer
                clearTimeout(timer)
                timer = setTimeout(() => {
                  const { entity } = res.data
                  const params = {
                    neid: entity.neid,
                    target_path: entity.path,
                    path_type: entity.path_type,
                    prefix_neid: entity.prefix_neid,
                    limit: '',
                    offset: 0,
                    include_deleted: false,
                  }
                  if (info.pathType === 'share_in' || info.pathType === 'share_out') {
                    params.prefix_neid = store.state.tempFileListState.tempShareInPrefixNeid
                    params.from = store.state.tempFileListState.tempShareInFrom
                    params.nsid = store.state.tempFileListState.tempNsid
                  }
                  postData('getMetadata', params).then((metaDataRes) => {
                    if (metaDataRes.status === 200) {
                      const self = vm
                      const newFolderData = metaDataRes.data
                      delete newFolderData.content
                      newFolderData.isfolder = newFolderData.is_dir
                      newFolderData.isDir = newFolderData.is_dir
                      newFolderData.checked = false
                      newFolderData.islocked = !!newFolderData.lock_uid
                      newFolderData.unlockAdmin = (newFolderData.lock_uid === Util.getUserID())
                      || Util.isAdmin()
                      newFolderData.data = [{
                        type: 'file',
                        showRename: false,
                        get value() {
                          return newFolderData.filename ? newFolderData.filename : newFolderData.path.split('/').pop()
                        },
                        fileMore: [],
                        class: 'filelist-icon',
                      }, {
                        get value() {
                          const isListMode = localStorage.getItem('Mode') === 'list'
                          if (isListMode) {
                            return `${Util.formatDate(newFolderData.modified, 'yyyy-MM-dd hh:mm')} | ${newFolderData.updator}`
                          }
                          return Util.formatDate(newFolderData.modified, 'yyyy-MM-dd hh:mm') + self.$t(' 由{n}创建', { n: newFolderData.updator })
                        },
                        class: 'update-date-updator',
                      }, {
                        get value() {
                          return newFolderData.is_dir ? '-' : Util.formatBytes(newFolderData.bytes)
                        },
                        class: 'update-size',
                      }]
                      store.commit('addCreateData', newFolderData)
                      vm.$emit('getCreateData', newFolderData)
                    }
                  }).catch((error) => {
                    const err = error.response.data
                    vm.$emit('showTips', err.message, 'error')
                  })
                }, 300)
              }
            }).catch((error) => {
              const err = error.response.data
              vm.$emit('showTips', err.message, 'error')
            })
          }
        }).catch((error) => {
          const err = error.response.data
          vm.$emit('showTips', err.message, 'error')
        })
      }
    },
    cancel() {
      const { vm } = this
      if (this.mountEl) {
        vm.close()
        return
      }
      store.commit('hasRename', false)
      store.commit('setCreateInput', false)
      const newFileBoxEle = document.getElementById('new-file-box')
      if (newFileBoxEle) {
        newFileBoxEle.parentNode.removeChild(newFileBoxEle)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.new-folder-tick{
  width:17px;
  height:12px;
  margin-bottom: -1px;
}
.new-folder-cancel{
  width:13px;
  height:13px;
  margin-bottom: -2px;
}
.re-icon{
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
}
.re-icon:hover{
  background-color:#e8ebef ;
  border-radius: 2px;
}
#new-file .file-area{
  position: relative;
}
.lui-filelist .list-wrapper.card-view .filelist-item #new-file .file-area input{
  box-sizing: border-box;
  padding-right: 60px;
  height: 32px;
}
.list-view #new-file .creat-file{
  box-sizing: border-box;
  width: calc(100% - 54px);
  padding-right: 60px;
  height: 32px;
}
.card-view .wrap-btns{
  position: absolute;
  top: 50%;
  right: 32px;
  height: 30px;
  line-height: 30px;
  margin: -13px 4px 0;
}
.card-mode .wrap-btns{
  right: 24px;
}
.list-view .wrap-btns{
  position: absolute;
  top: 50%;
  height: 30px;
  line-height: 30px;
  right: 14px;
  margin: -14px 4px 0;
  display: flex;
  align-items: center;
}
</style>
